import { ComponentProps, FC, ReactElement, createElement } from 'react';
import Skeleton from '@loomstateorg/shared-frontend/components/commercetools-ui/atoms/skeleton';
import FeedbackIconLayer from './feedbackIconLayer';
import type { ButtonIconPosition, ButtonSize, ButtonVariant } from './types';

export type { ButtonIconPosition, ButtonSize, ButtonVariant } from './types';

export interface ButtonProps extends ComponentProps<'button'> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  iconPosition?: ButtonIconPosition;
  icon?: ReactElement;
  loading?: boolean;
  added?: boolean;
  asSkeleton?: boolean;
  /** Pre-resolved class names from the client's useButtonClassNames adapter. */
  buttonClassName?: string;
  feedbackPrimaryBg?: string;
  feedbackFallbackBg?: string;
}

const Button: FC<ButtonProps> = ({
  icon,
  added,
  loading,
  children,
  className,
  disabled,
  asSkeleton = false,
  variant = 'primary',
  iconPosition = 'middle',
  size: _size,
  buttonClassName,
  feedbackPrimaryBg,
  feedbackFallbackBg,
  ...props
}) => {
  const { ['data-testid']: dataTestId, ...rest } = props as ComponentProps<'button'> & {
    'data-testid'?: string;
  };

  const resolvedClassName = buttonClassName ?? className ?? '';

  // createElement + any avoids dual @types/react Ref incompatibilities across workspace packages.
  return createElement(
    'button',
    {
      ...(rest as object),
      'data-component-group': 'button',
      'data-testid': dataTestId ?? 'atom-button',
      className: resolvedClassName,
      disabled: disabled || loading,
    } as any,
    (loading || added) && createElement(FeedbackIconLayer, { loading, variant, feedbackPrimaryBg, feedbackFallbackBg }),
    icon && iconPosition !== 'right' && icon,
    children,
    icon && iconPosition == 'right' && icon,
    asSkeleton && createElement(Skeleton, null),
  ) as any;
};

export default Button;
